var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#E7E5E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C11.5417 12 11.1493 11.8368 10.8229 11.5104C10.4965 11.184 10.3334 10.7917 10.3334 10.3333C10.3334 9.87499 10.4965 9.48263 10.8229 9.15624C11.1493 8.82985 11.5417 8.66666 12 8.66666C12.4584 8.66666 12.8507 8.82985 13.1771 9.15624C13.5035 9.48263 13.6667 9.87499 13.6667 10.3333C13.6667 10.7917 13.5035 11.184 13.1771 11.5104C12.8507 11.8368 12.4584 12 12 12ZM8.66669 15.3333V14.1667C8.66669 13.9305 8.72745 13.7135 8.84898 13.5156C8.97051 13.3177 9.13196 13.1667 9.33335 13.0625C9.76391 12.8472 10.2014 12.6858 10.6459 12.5781C11.0903 12.4705 11.5417 12.4167 12 12.4167C12.4584 12.4167 12.9097 12.4705 13.3542 12.5781C13.7986 12.6858 14.2361 12.8472 14.6667 13.0625C14.8681 13.1667 15.0295 13.3177 15.1511 13.5156C15.2726 13.7135 15.3334 13.9305 15.3334 14.1667V15.3333H8.66669ZM9.50002 14.5H14.5V14.1667C14.5 14.0903 14.4809 14.0208 14.4427 13.9583C14.4045 13.8958 14.3542 13.8472 14.2917 13.8125C13.9167 13.625 13.5382 13.4844 13.1563 13.3906C12.7743 13.2969 12.3889 13.25 12 13.25C11.6111 13.25 11.2257 13.2969 10.8438 13.3906C10.4618 13.4844 10.0834 13.625 9.70835 13.8125C9.64585 13.8472 9.59551 13.8958 9.55731 13.9583C9.51912 14.0208 9.50002 14.0903 9.50002 14.1667V14.5ZM12 11.1667C12.2292 11.1667 12.4254 11.0851 12.5886 10.9219C12.7518 10.7587 12.8334 10.5625 12.8334 10.3333C12.8334 10.1042 12.7518 9.90798 12.5886 9.74478C12.4254 9.58159 12.2292 9.49999 12 9.49999C11.7709 9.49999 11.5747 9.58159 11.4115 9.74478C11.2483 9.90798 11.1667 10.1042 11.1667 10.3333C11.1667 10.5625 11.2483 10.7587 11.4115 10.9219C11.5747 11.0851 11.7709 11.1667 12 11.1667Z",
    fill: "#1A1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.582ef112286aa80da688d1e4f154de4f.svg";
export { ForwardRef as ReactComponent };